import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatiteEViewComponent.vue?vue&type=template&id=1fa63e02"
import script from "./IndagineEpidemiologicaEpatiteEViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatiteEViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports